<template>
    <el-select
        v-if="mode == 'edit'"
        v-model="localValue.numericValue"
        filterable
        :placeholder="prop.placeholder"
        class="wp-10"
    >
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
        >
        </el-option>
    </el-select>
    <p v-else>
        {{ label }}
    </p>
</template>

<script>
import CfMixin from '../../../mixins/CustomfieldInputsMixins';
import { deepEqual } from 'Helpers/deepEqual';

export default {
    mixins: [CfMixin],
    emits: ['update:modelValue'],
    data() {
        return {
            localValue: this.value,
        };
    },
    computed: {
        label() {
            const option = this.options.find(
                (value) => parseInt(value.id) == this.localValue.numericValue,
            );
            return option ? option.name : '';
        },
        options() {
            const options = [...this.prop.allowedValues];
            options.unshift({
                default: false,
                id: 0,
                longName: this.$l10n.__('Aucun'),
                name: this.$l10n.__('Aucun'),
            });
            return options;
        },
    },
    watch: {
        localValue: {
            handler: function (newValue, oldValue) {
                if (!deepEqual(newValue, oldValue)) {
                    this.$emit('update:modelValue', newValue);
                }
            },
        },
        value: {
            handler: function (newValue, oldValue) {
                if (!deepEqual(newValue, oldValue)) {
                    this.localValue = newValue;
                }
            },
            deep: true,
        },
    },
    created() {
        if (!this.localValue) {
            this.setLocalValue();
        }
    },
    methods: {
        setLocalValue() {
            this.localValue = JSON.parse(JSON.stringify(this.templateData));
            if (this.prop.allowedValues.length > 0 && this.mode === 'edit') {
                const defaultValue = this.prop.allowedValues.find((allowed) => allowed.default);
                this.localValue.numericValue = defaultValue ? parseInt(defaultValue.id) : null;
            } else {
                this.localValue.numericValue = null;
            }
        },
    },
};
</script>
